export default {
  name: 'modalNDA',
  props: [],
  components: {},
  data() {
    return {
      signaturePad: null,
    }
  },
  filters: {},
  methods: {
    clearESign() {
      this.signaturePad.clear()
    },
    eSign() {
      this.$emit('eSign')
      $('#modalNDA').modal('close')
    },
  },
  computed: {},
  beforeCreate () {},
  created() {},
  mounted() {
    // Set PDF file in viewer
    var urlMakePdf = "https://beta.greeneum.net/static/GreeneumAgreementNDA.pdf"
    this.$refs.iframePdf.innerHTML = '<iframe id="iframePdf" height="400px" width="80%" allowfullscreen webkitallowfullscreen src="https://beta.greeneum.net/static/ViewerJS/index.html#' + urlMakePdf + '"></iframe>'

    // Set options during initialization:
    var canvas = this.$refs.signaturePadCanvas
    this.signaturePadNda = new SignaturePad(canvas, {
      // It's Necessary to use an opaque color when saving image as JPEG;
      // this option can be omitted if only saving as PNG or SVG
      backgroundColor: 'rgb(255, 255, 255)'
    })
  },
}


// WEBPACK FOOTER //
// ./src/components/Project/SystemsDetail/ProjectCrowdfundingAdd/ModalNDA/ModalNDA.component.js